<h1 mat-dialog-title [kitText]="titleText"></h1>
<div mat-dialog-content>
  <span [kitText]="noTagsText" *ngIf="tagTable.tagList.size <= 0"></span>
  <app-tag-table [model]="tagTable"></app-tag-table>
</div>
<div mat-dialog-actions>
  <kit-bs-button [kitModel]="assignTokenAction"></kit-bs-button>
</div>
